import { DialogEditor, RenderEditCellProps } from 'components/DataGrid';
import type { GridRow } from '../../types';
import { ReactNode } from 'react';
import { FormFields } from './FormFields';
import { usePlanMutations } from '../../state';

export function Edit(props: RenderEditCellProps<GridRow, any> & { month: string }): ReactNode {
  const { update } = usePlanMutations();
  const { row, month } = props;
  const delivery = row.delivery[month];
  const monthSum = row.months[month];

  return (
    <DialogEditor
      {...props}
      submitHandler={async (values) => {
        const res = await update({
          rows: { upsert: [{ id: row.id, delivery: { ...row.delivery, [month]: values } }] },
        });
        // The whole `delivery` dict is validated server-side, so a bad field on the edited
        // month comes back keyed by its month isostring (e.g. `{ "2026-01-01": { quantity:
        // [...] } }`). Narrow it to the edited month so this single-month form can bind it.
        const err = res.unwrapFormError();
        if (!err) {
          return;
        }
        return (err[month] as typeof err) ?? err;
      }}
      dialogHeader={<strong>{props.column.name}</strong>}
      testId="month-sum-edit"
      initialValues={
        delivery
          ? delivery
          : {
              quantity: monthSum ? monthSum.target_provider_quantity : null,
              total: null,
              alt_prices: false,
              alt_quantity: monthSum ? monthSum.target_client_quantity : null,
              alt_total: null,
            }
      }
      onRemove={
        delivery
          ? async () => {
              const { [month]: _removed, ...rest } = row.delivery;
              const res = await update({ rows: { upsert: [{ id: row.id, delivery: rest }] } });
              res.unwrap();
            }
          : undefined
      }
    >
      <FormFields />
    </DialogEditor>
  );
}
